import Table from "@mui/material/Table"
import { IRunEvent } from "../../interface/IRunEvent"
import { LogsHeader } from "./LogsHeader"
import { LogItem } from "./LogItem"
import TableBody from "@mui/material/TableBody"
import TableContainer from "@mui/material/TableContainer"
import Paper from "@mui/material/Paper"
import { alpha, useTheme } from "@mui/material/styles"

interface LogsTableProps
{
  logs: IRunEvent[] | undefined
  setShowOrderDetails: (show: IRunEvent | undefined) => void
}

export const LogsTable = ({ logs, setShowOrderDetails }: LogsTableProps) =>
{
  const theme = useTheme()
  return(
    <TableContainer
      component={Paper}
      sx={{
        ...styles.body,
        borderRadius: "14px",
        border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.6)}`,
        backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.03 : 0.72),
      }}
    >
      <Table component={Paper}>
      <LogsHeader />
      <TableBody>
        {logs && logs.map((row, key) => <LogItem key={key} row={row} setShowOrderDetails={setShowOrderDetails} />)}
      </TableBody>
    </Table>
  </TableContainer>
  )
}

const styles = {
  body: {
    overflow: "auto",
    height: "78vh"
  }
}
